import React from "react";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";

export function Layout({ children }) {
  return (
    <div className="App grain min-h-screen bg-coal text-offwhite">
      <Navbar />
      <main>{children}</main>
      <Footer />
    </div>
  );
}
